import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useCallback, useEffect } from 'react';
import styles from '../styles/chatbot.module.scss.js';
import * as ReactDOM from 'react-dom';
import img from '../../../assets/stars-2x.png.js';
import { WIDGET_ID, eventHorizonCookiePreferencesModalId } from '../../../config/constants.js';

const HighlightExplain = ({ onExplain, expandIfClosed }) => {
    const [showButton, setShowButton] = useState(false);
    const [buttonPosition, setButtonPosition] = useState({ top: 0, left: 0 });
    const [selectedText, setSelectedText] = useState('');
    const handleMouseUp = () => {
        const selection = window.getSelection();
        if (selection &&
            selection.rangeCount > 0 &&
            selection.toString().trim() !== '') {
            if (ancestorContainChatBotDiv(selection.anchorNode) || ancestorContainChatBotDiv(selection.focusNode)) {
                return;
            }
            const range = selection.getRangeAt(0);
            const rect = range.getBoundingClientRect();
            setSelectedText(selection.toString());
            setButtonPosition({
                top: rect.top + window.scrollY - 5,
                left: rect.left + window.scrollX + rect.width + 12
            });
            setShowButton(true);
        }
        else {
            setShowButton(false);
        }
    };
    const onButtonClicked = useCallback(() => {
        expandIfClosed();
        onExplain(selectedText);
    }, [expandIfClosed, onExplain, selectedText]);
    useEffect(() => {
        document.addEventListener('mouseup', handleMouseUp);
        return () => {
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, []);
    const button = showButton ? (jsxs("button", { className: styles['explain-button'], style: {
            position: 'absolute',
            top: `${buttonPosition.top}px`,
            left: `${buttonPosition.left}px`
        }, onClick: () => onButtonClicked(), "data-testid": 'explainButton', children: ["Explain with", ' ', jsx("img", { src: img, alt: 'Stars', className: styles['explain-stars'] }), "Assistant", jsx("div", { className: styles['tooltip-arrow'] })] })) : null;
    return ReactDOM.createPortal(button, document.body);
};
function ancestorContainChatBotDiv(node) {
    if (node === null) {
        return false;
    }
    if (node.parentElement && (node.parentElement.getAttribute("id") === WIDGET_ID || node.parentElement.getAttribute("id") === eventHorizonCookiePreferencesModalId)) {
        return true;
    }
    return ancestorContainChatBotDiv(node.parentNode);
}

export { HighlightExplain as default };
